module.exports = __webpack_public_path__ + "static/media/gd.64b1a583.svg";